<template>
    <div id="merge-contacts-modal"
         class="modal fade pt-48"
         tabindex="-1"
         role="dialog"
         style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <form class="form">
                        <div class="form-group mt-3">
                            <h5 class="text-center mb-4">Merge {{ form.contacts_to_merge_ids ? form.contacts_to_merge_ids.length : 0 }} selected {{ 'contact' | pluralizeOnlyS(form.contacts_to_merge_ids ? form.contacts_to_merge_ids.length : 0) }} into</h5>

                            <div class="col-sm-12">
                                <el-select
                                    class="w-100"
                                    v-model="form.target_contact"
                                    @focus="searchContacts('')"
                                    filterable
                                    remote
                                    placeholder="Select target contact"
                                    :remote-method="searchContacts"
                                    :loading="loading">
                                    <el-option
                                        v-for="contact in suggestedContacts"
                                        :key="contact.id"
                                        :label="contact.full_name"
                                        :value="contact.id">

                                        <div class="relative flex items-center justify-between">
                                            <div>
                                                <span>{{ contact.full_name }}</span>
                                                <span v-if="contact.external_source !== null"
                                                      class="mdi mdi-link-variant text-muted position-absolute"
                                                      style="top: -10px; margin-left: 0; font-size: .5rem">
                                                    {{ contact.external_source }}
                                                </span>
                                            </div>
                                            <div class="text-sx  flex">
                                                <div class="inline flex items-center"><i class="mdi mdi-home"></i> <span>{{ contact.assets_count }}</span></div>
                                            </div>
                                        </div>
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="form-group col-sm-12">
                                <div class="starting-point mt-3">
                                    NOTE: All links to <b>assets</b>, <b>service providers</b>, <b>inspections</b> &
                                    <b>tickets</b> will be replaced with the selected contact. Contacts linked to an active integration cannot be merged into another
                                    contact and will be skipped. <!--but can be merged into a linked contact-->
                                </div>
                            </div>

                            <div class="form-group col-sm-12">
                                <el-checkbox class="flex-grow-1 justify-content-start ml-0 font-weight-normal"
                                             v-model="form.archive_after_merge">
                                    Archive selected contacts after merge
                                </el-checkbox>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-default waves-effect" data-dismiss="modal"
                            :disabled="form.busy">Cancel
                    </button>

                    <button class="btn btn-success waves-effect waves-light"
                            @click.prevent="mergeIntoOtherContact"
                            :disabled="form.busy">{{ form.busy ? 'Creating merge job...' : 'Merge' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "merge-contacts-modal",
    props: ["selectedContacts"],

    data () {
        return {
            loading: false,
            form: new AppForm({
                "archive_after_merge": true,
                "target_contact": null,
                "contacts_to_merge_ids": this.selectedContacts
            }),
            suggestedContacts: [],
            query: null,
        };
    },

    watch: {
        selectedContacts (newVal) {
            this.form.contacts_to_merge_ids = newVal;
        }
    },

    methods: {
        searchContacts (query) {
            this.loading = true;
            axios.get("/contacts/search-to-link", {
                params: {
                    filter_text: query,
                    excluded_ids: this.selectedContacts,
                }
            }).then((response) => {
                this.suggestedContacts = response.data;
                this.loading = false;
            }).catch(() => {
                toastr.error("Could not find any matching contacts!");
                this.loading = false;
            });
        },

        mergeIntoOtherContact () {
            App.patch("/contacts/merge", this.form)
            .then((response) => {
                toastr.success(response);
                this.$emit("contacts-merged");
            }).catch((error) => {
                toastr.error("Could not merge contacts! Error: " + error.message);
            });
        },
    },
};
</script>